// src/components/Header/HeaderSignedOut.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const HeaderSignedOut = () => {
  const navigate = useNavigate();

  return (
    <header>
      <div className="container-fluid">
        <div className="row middle-xs">
          <div className="col-xs-6 justify-left">
            <Link to="/">
              <img src="/images/Logo.svg" alt="Logo" />
            </Link>
          </div>
          <div className="col-xs-6 justify-right">
            <button 
              className="white signup-button" 
              onClick={() => navigate("/signup")}
            >
              Sign Up
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderSignedOut;
